import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of, tap } from 'rxjs';
import { RootState } from '..';
import { AzureMonitoringService } from '../../services/AzureMonitoringService';
import { RelocationRestService } from '../../services/rest/relocation.rest.service';
import { AbstractEffects } from '../AbstractEffects';
import * as actions from './relocation-detail.actions';
import { RelocationDetailCreateRemoveMaterialAction, RelocationDetailCreateSaveMaterialStartAction, RelocationDetailOpenAction } from './relocation-detail.actions';
import { catchError, debounceTime, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { NotificationService } from 'app/core/services/notification.service';

@Injectable({ providedIn: 'root' })
export class RelocationDetailEffects extends AbstractEffects {
  calculateLoadAddMaterialSkipPalletFloorQuantity$ = createEffect(() =>
    this.actions$.pipe(
      ofType<RelocationDetailCreateSaveMaterialStartAction>(actions.RELOCATIONDETAIL_CREATE_SAVE_MATERIAL_START),
      switchMap((action: RelocationDetailCreateSaveMaterialStartAction) => {
        return of(
          new actions.RelocationDetailCreateSaveMaterialSuccessAction({
            calculation: null,
            material: action.payload.material,
          })
        );
      })
    )
  );

  calculateAfterRemoveMaterial$ = createEffect(() =>
    this.actions$.pipe(
      ofType<RelocationDetailCreateRemoveMaterialAction>(actions.RELOCATIONDETAIL_CREATE_DELETE_MATERIAL),
      withLatestFrom(this.store, (action: RelocationDetailCreateRemoveMaterialAction, state) => {
        return { payload: action.payload, state };
      }),
      tap(({ payload, state }) => {
        this.notificationService.showToastr({
          type: 'success',
          messageCode: 'ORDERS.MATERIAL.NOTIFICATIONS.MATERIAL_REMOVED',
          disableClose: false,
        });
      })
    ), {dispatch: false}
  );

  loadRelocation$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<RelocationDetailOpenAction>(actions.RELOCATIONDETAIL_OPEN),
      debounceTime(50),
      map((action: RelocationDetailOpenAction) => action.payload),
      switchMap((ids: { etmOrderNumber; salesOrderNumber }) => {
        return this.relocationRestService.getRelocation(ids.etmOrderNumber, ids.salesOrderNumber).pipe(
          map(result => new actions.RelocationDetailOpenSuccessAction(result)),
          catchError(err => this.handleFail(err, 'RELOCATIONS.LABELS.OPEN_RELOCATION', [of(new actions.RelocationDetailOpenFailAction(err))]))
        );
      })
    )
  );

  constructor(
    private store: Store<RootState>,
    azureMonitoringService: AzureMonitoringService,
    private actions$: Actions,
    private relocationRestService: RelocationRestService,
    translateService: TranslateService,
    public dialog: MatDialog,
    notificationService: NotificationService
  ) {
    super(translateService, azureMonitoringService, notificationService);
  }
}
